import { useTranslation } from 'react-i18next';

import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';

import MomentTemplateEditor from './MomentTemplateEditor';

export default function MomentTemplateModal({
	url,
	name,
	returnURL,
}: {
	url: string;
	name: string;
	returnURL: string;
}) {
	const { t } = useTranslation();

	return (
		<ModalBackground>
			<Modal width={8 / 12}>
				<ModalHeader returnUrl={returnURL}>
					<ModalHeaderTitle>{t('common.settings.momentTemplates.edit.title')}</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					<MomentTemplateEditor url={url} returnURL={returnURL} name={name} />
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
